import React, {useContext, useReducer} from "react";
import {GlobalInfo} from "./context";
import {database} from "./config";
import {MaterialList, Toggle} from "./Common";

function saveTargets(newTargets) {
    let batch = database.batch();
    for (let [name, value] of Object.entries(newTargets)) {
      let doc = database.collection("recipes").doc(name);
      let updates = {
        "target": value,
      };
      batch.update(doc, updates);
    }
    return batch.commit()
}

export function TargetPage() {
  let context = useContext(GlobalInfo);

  let materials = {};
  context.recipes.forEach((recipe) => {
    if(!recipe.blueprintMaterials) {
      return;
    }
    for (const [name, amt] of Object.entries(recipe.blueprintMaterials)) {
      materials[name] = (materials[name] || 0) + amt * (recipe.target || 0);
    }
  });
  console.log(materials);

  let [newTargets, setNewTargets] = useReducer((state, action) => {
    let [name, newValue] = action;
    return Object.assign({}, state, {[name]: newValue})
  }, {});

  return <div className={"container"}>

    <button className={"btn btn-success"} onClick={() => saveTargets(newTargets)}>
      Save
    </button>

    <MaterialList materials={materials} />

    <table className={"table table-striped table-bordered"}>
      <thead>
      <tr>
        <td>Ship</td>
        <td>Target</td>
      </tr>
      </thead>
      <tbody>
      {context.recipes.map((recipe) => {
        return <tr key={recipe.name}>
          <td>{recipe.name} {newTargets[recipe.name]}</td>
          <td><input
              type={"number"}
              value={(newTargets[recipe.name] === undefined) ? (recipe.target || 0) : newTargets[recipe.name]}
              onChange={(e) => setNewTargets([recipe.name, e.target.value])}
          /></td>
          <td>
            <Toggle>
              <MaterialList materials={recipe.blueprintMaterials} />
            </Toggle>
          </td>
        </tr>
      })}
      </tbody>
    </table>
  </div>
}